<template>
  <div
    :data-podcast-uuid="show_data && show_data.uuid ? show_data.uuid : ''"
    :class="`show-details detail-page ${isShowExclusive ? 'is-exclusive' : ''}`"
    data-test="page-showdetail">
    <PremiumBanner
      v-if="show_data && show_data.uuid && show_data.is_exclusive && showPremiumBanner && data_loaded"
      :show="show_data"
      :title="show_data.title"
      class="hidden-xs-only"
    />
    <loader
      v-show="!data_loaded"
      :center="true"
      label="Fetching Podcast Details.."
    />
    <div
      v-if="isShowExclusive"
      class="content-wrapper"
    >
      <div
        :style="{backgroundImage: `url(${show_data.image_url})`}"
        class="cover-section"
      >
        <div class="container">
          <div class="cover-section__content">
            <div class="show-image">
              <picture-component
                :src="show_data.display_image_url"
                data-test="show-image"
              />

              <div
                v-if="(season_trailers && season_trailers.length) && isLoggedIn"
                class="trailer-button1"
                data-test="trailer-button1"
                round
                @click="playTrailer">
                <img
                  v-if="!isPlayingTrailer && !isLoadingTrailer"
                  class="textTrailer"
                  width="16"
                  src="./../assets/images/ic_play_symbol_white.svg">
                <img
                  v-if="isPlayingTrailer && !isLoadingTrailer"
                  class="textTrailer pause-icon"
                  width="16"
                  src="./../assets/images/ic_player_pause.svg">
                <i
                  v-if="isLoadingTrailer"
                  class="el-icon-loading"
                />
                <span>Trailer</span>
              </div>
            </div>

            <div class="cover-section__content__text">
              <Breadcrumb
                v-if="breadcrumbTrail.length"
                :trail="breadcrumbTrail"
              />
              <PremiumIndicator v-if="show_data.is_exclusive" />

              <h2
                class="show-title"
                data-test="showtitle">{{ show_data.title | truncate(82) }}
              </h2>
              <p
                v-if="show_data.publisher"
                class="publisher"
                data-test="publishertitle"
                @click="$router.push(`/listen/${show_data.publisher.slug}/${show_data.publisher.uuid}?page=1`)"
              >
                By {{ show_data.publisher.name }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="content-wrapper__details">
        <div class="container">
          <div
            class="interact"
          >
            <el-button
              v-if="!isLoadingTrailer && !isLoggedIn && (season_trailers && season_trailers.length)"
              class="m-r btn-primary-transparent play-button icon-button"
              @click="playTrailer">
              <i
                v-if="!isPlayingTrailer"
                class="fas fa-play"/>
              <i
                v-if="isPlayingTrailer"
                class="fas fa-pause"/>
              <span>{{ isPlayingTrailer ? 'Pause Trailer' : 'Play Trailer' }}</span>
            </el-button>

            <el-button
              v-if="isLoadingTrailer && !isLoggedIn && (season_trailers && season_trailers.length)"
              class="m-r btn-primary-transparent icon-button"
            >
              <i class="el-icon-loading"/>
              <span data-test="btn-playtrailer">Play Trailer</span>
            </el-button>

            <el-button
              v-if="isLoggedIn && ((isShowExclusive && hasAccessToPremium) || !isShowExclusive || hasFreeEpisodes)"
              :icon="!inUserLibrary || !inUserLibrary.uuid ? 'el-icon-plus': 'el-icon-check'"
              :loading="adding_podcast"
              class="icon-button btn-primary-transparent"
              data-test="btn-addtomyshow"
              @click="addShowToLibrary(show_data.uuid)">
              {{ inUserLibrary && inUserLibrary.uuid ? 'Added to My Shows' : 'Add to My Shows' }}
            </el-button>

            <rating
              v-if="isLoggedIn && ((isShowExclusive && hasAccessToPremium) || !isShowExclusive || hasFreeEpisodes)"
              :show_like="true"
              :show_dislike="true"
              :podcast_id="show_data.uuid"
              type="show"
              data-test="rating"/>
          </div>

          <div class="description">
            <p
              v-if="showingMoreDescription"
              data-test="show-description"
              v-html="$sanitize(show_data.description)"
            />
            <p
              v-if="!showingMoreDescription"
              data-test="show-description"
              v-html="$sanitize($options.filters.truncate(show_data.description, 400))"
            />
            <el-button
              v-if="show_data.description.length > 400"
              class="read-more"
              type="text"
              @click="toggleDescription"
            >
              Read {{ showingMoreDescription ? 'Less' : 'More' }}
              <i :class="`el-icon-arrow-${showingMoreDescription ? 'up' : 'down'}`" />
            </el-button>
          </div>


          <div class="social">
            <SocialShareDialog
              :show-data="show_data"
              type="podcast"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isShowExclusive"
      class="content-wrapper is-mobile"
    >
      <PodcastCover
        v-if="isShowExclusive"
        :src="show_data.image_url"
      />
      <div
        v-if="data_loaded && show_data && show_data.uuid"
        class="show-details__info container"
      >
        <div class="show-image">
          <picture-component
            :src="show_data.display_image_url"
            data-test="show-image"
          />

          <div
            v-if="(season_trailers && season_trailers.length) && isLoggedIn"
            class="trailer-button1"
            round
            @click="playTrailer">
            <img
              v-if="!isPlayingTrailer && !isLoadingTrailer"
              class="textTrailer"
              width="16"
              src="./../assets/images/ic_play_symbol_white.svg">
            <img
              v-if="isPlayingTrailer && !isLoadingTrailer"
              class="textTrailer pause-icon"
              width="16"
              src="./../assets/images/ic_player_pause.svg">
            <i
              v-if="isLoadingTrailer"
              class="el-icon-loading"
            />
            <span>Trailer</span>
          </div>
        </div>

        <div class="text">
          <Breadcrumb
            v-if="breadcrumbTrail.length"
            :trail="breadcrumbTrail"
          />
          <PremiumIndicator v-if="show_data.is_exclusive" />
          <h2
            class="show-title"
            data-test="showtitle">{{ show_data.title | truncate(82) }}
            {{ show_data.title | truncate(82) }}
          </h2>
          <p
            v-if="show_data.publisher"
            class="publisher"
            data-test="publishertitle"
            @click="$router.push(`/listen/${show_data.publisher.slug}/${show_data.publisher.uuid}?page=1`)"
          >
            By {{ show_data.publisher.name }}
          </p>

          <div
            class="interact"
          >
            <el-button
              v-if="!isLoadingTrailer && !isLoggedIn && (season_trailers && season_trailers.length)"
              class="m-r btn-primary-transparent play-button icon-button"
              @click="playTrailer">
              <i
                v-if="!isPlayingTrailer"
                class="fas fa-play"/>
              <i
                v-if="isPlayingTrailer"
                class="fas fa-pause"/>
              <span>{{ isPlayingTrailer ? 'Pause Trailer' : 'Play Trailer' }}</span>
            </el-button>

            <el-button
              v-if="isLoadingTrailer && !isLoggedIn && (season_trailers && season_trailers.length)"
              class="m-r btn-primary-transparent icon-button"
            >
              <i class="el-icon-loading"/>
              <span data-test="btn-playtrailer">Play Trailer</span>
            </el-button>

            <el-button
              v-if="isLoggedIn && ((isShowExclusive && hasAccessToPremium) || !isShowExclusive || hasFreeEpisodes)"
              :icon="!inUserLibrary || !inUserLibrary.uuid ? 'el-icon-plus': 'el-icon-check'"
              :loading="adding_podcast"
              class="icon-button btn-primary-transparent"
              data-test="btn-addtomyshow"
              @click="addShowToLibrary(show_data.uuid)">
              {{ inUserLibrary && inUserLibrary.uuid ? 'Added to My Shows' : 'Add to My Shows' }}
            </el-button>

            <rating
              v-if="isLoggedIn && ((isShowExclusive && hasAccessToPremium) || !isShowExclusive || hasFreeEpisodes)"
              :show_like="true"
              :show_dislike="true"
              :podcast_id="show_data.uuid"
              type="show"
              data-test="rating"/>
          </div>

          <div class="description">
            <p
              v-if="showingMoreDescription"
              data-test="show-description"
              v-html="$sanitize(show_data.description)"
            />
            <p
              v-if="!showingMoreDescription"
              data-test="show-description"
              v-html="$sanitize($options.filters.truncate(show_data.description, 400))"
            />
            <el-button
              v-if="show_data.description.length > 400"
              class="read-more"
              type="text"
              @click="toggleDescription"
            >
              Read {{ showingMoreDescription ? 'Less' : 'More' }}
              <i :class="`el-icon-arrow-${showingMoreDescription ? 'up' : 'down'}`" />
            </el-button>
          </div>


          <div class="social">
            <SocialShareDialog
              :show-data="show_data"
              type="podcast"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!isShowExclusive"
      class="content-wrapper"
    >
      <div
        v-if="data_loaded && show_data && show_data.uuid"
        class="show-details__info container"
      >
        <div class="show-image">
          <picture-component
            :src="show_data.display_image_url"
            data-test="show-image"
          />

          <div
            v-if="(season_trailers && season_trailers.length) && isLoggedIn"
            class="trailer-button1"
            round
            @click="playTrailer">
            <img
              v-if="!isPlayingTrailer && !isLoadingTrailer"
              class="textTrailer"
              width="16"
              src="./../assets/images/ic_play_symbol_white.svg">
            <img
              v-if="isPlayingTrailer && !isLoadingTrailer"
              class="textTrailer pause-icon"
              width="16"
              src="./../assets/images/ic_player_pause.svg">
            <i
              v-if="isLoadingTrailer"
              class="el-icon-loading"
            />
            <span>Trailer</span>
          </div>
        </div>

        <div class="text">
          <Breadcrumb
            v-if="breadcrumbTrail.length"
            :trail="breadcrumbTrail"
          />

          <h2
            class="show-title"
            data-test="showtitle">{{ show_data.title | truncate(82) }}
          </h2>
          <p
            v-if="show_data.publisher"
            class="publisher"
            data-test="publishertitle"
            @click="$router.push(`/listen/${show_data.publisher.slug}/${show_data.publisher.uuid}?page=1`)"
          >
            By {{ show_data.publisher.name }}
          </p>

          <div
            class="interact"
          >
            <el-button
              v-if="!isLoadingTrailer && !isLoggedIn && (season_trailers && season_trailers.length)"
              class="m-r btn-primary-transparent play-button icon-button"
              @click="playTrailer">
              <i
                v-if="!isPlayingTrailer"
                class="fas fa-play"/>
              <i
                v-if="isPlayingTrailer"
                class="fas fa-pause"/>
              <span>{{ isPlayingTrailer ? 'Pause Trailer' : 'Play Trailer' }}</span>
            </el-button>

            <el-button
              v-if="isLoadingTrailer && !isLoggedIn && (season_trailers && season_trailers.length)"
              class="m-r btn-primary-transparent icon-button"
            >
              <i class="el-icon-loading"/>
              <span data-test="btn-playtrailer">Play Trailer</span>
            </el-button>

            <el-button
              v-if="isLoggedIn && ((isShowExclusive && hasAccessToPremium) || !isShowExclusive || hasFreeEpisodes)"
              :icon="!inUserLibrary || !inUserLibrary.uuid ? 'el-icon-plus': 'el-icon-check'"
              :loading="adding_podcast"
              class="icon-button btn-primary-transparent"
              data-test="btn-addtomyshow"
              @click="addShowToLibrary(show_data.uuid)">
              {{ inUserLibrary && inUserLibrary.uuid ? 'Added to My Shows' : 'Add to My Shows' }}
            </el-button>

            <rating
              v-if="isLoggedIn && ((isShowExclusive && hasAccessToPremium) || !isShowExclusive || hasFreeEpisodes)"
              :show_like="true"
              :show_dislike="true"
              :podcast_id="show_data.uuid"
              type="show"
              data-test="rating"/>
          </div>

          <div class="description">
            <p
              v-if="showingMoreDescription"
              data-test="show-description"
              v-html="$sanitize(show_data.description)"
            />
            <p
              v-if="!showingMoreDescription"
              data-test="show-description"
              v-html="$sanitize($options.filters.truncate(show_data.description, 400))"
            />
            <el-button
              v-if="show_data.description.length > 400"
              class="read-more"
              type="text"
              @click="toggleDescription"
            >
              Read {{ showingMoreDescription ? 'Less' : 'More' }}
              <i :class="`el-icon-arrow-${showingMoreDescription ? 'up' : 'down'}`" />
            </el-button>
          </div>


          <div class="social">
            <SocialShareDialog
              :show-data="show_data"
              type="podcast"
            />
          </div>
        </div>
      </div>
    </div>
    <PremiumBanner
      v-if="show_data && show_data.uuid && show_data.is_exclusive && showPremiumBanner && data_loaded"
      :show="show_data"
      :title="show_data.title"
      class="hidden-sm-and-up"
    />

    <div
      v-if="data_loaded && episodesList.length"
      class="episodes-count container"
    >
      <p data-test="count-episode">{{ totalEpisodes + (totalEpisodes === 1 ? ' Episode' : ' Episodes') }} </p>

      <el-select
        v-model="filter_value"
        :popper-append-to-body="false"
        class="sortIcon episode-sort"
        placeholder="Newest"
        @change="filterSelect">
        <el-option
          v-for="elem in select_filters"
          :key="elem.val"
          :label="elem.name"
          :value="elem.val"/>
      </el-select>
    </div>

    <div
      v-show="data_loaded && show_data && show_data.uuid"
      class="episodes-list-container container">
      <Loader
        v-if="loadingEpisodes"
        :absolute="true"
        :centralize="true"
      />
      <div class="episodes-list">
        <div v-if="show_data && data_loaded">
          <card-list-wrapper
            :episodes="episodesList"
            :podcast="show_data"
            :show-seasons="true"
            :show-premium-icon="false"
            :bucket="{
              bucket_uuid: null,
              name: 'Episodes',
              bucket_type:'sdp_episodes',
              position: 0,
              items_count: episodesList.length,
              media_size: 'episode_details'
            }"
            playlist-type="show"
          />
        </div>
      </div>
    </div>

    <el-row
      v-if="!no_more_data"
      :class="`container ${totalEpisodes <= page_size ? 'p' : ''}`"
      type="flex"
      justify="center"
    >
      <el-pagination
        v-show="totalEpisodes > page_size"
        v-if="data_loaded"
        :page-size="page_size"
        :total="totalEpisodes"
        :page-count="pager_count"
        layout="prev, pager, next"
        @current-change="loadNextPage($event)"/>
    </el-row>

    <MoreOfCategory
      v-if="show_data && podcastCategory"
      :category="podcastCategory"
    />
    <el-alert
      v-show="data_loaded && show_data && !show_data.uuid"
      :closable="false"
      class="container"
      title="Podcast details not found."
      type="warning"
      show-icon
      center
    />
    <login-modal
      v-if="show_login"
      :show_modal="show_login"
      @modalClosed="show_login = false"/>
    <premium-modal
      v-if="show_premium_modal"
      :show_modal="show_premium_modal"
      @modalClosed="show_premium_modal = false" />
  </div>
</template>

<script>
import * as log from 'loglevel';
import Loader from '../components/Loader';
import PremiumBanner from '../components/PremiumBanner';
import Podcast from '../services/Podcast';
import Episode from '../services/Episode';
import CardListWrapper from '../components/CardListWrapper';
import PodcastList from '../components/PodcastList';
import LoginModal from '../components/LoginModal';
import PremiumContentModal from '../components/PremiumContentModal';
import User from '../services/User';
import PodcastCard from '../components/PodcastCard';
import Rating from '../components/Rating';
import SocialShareDialog from '../components/SocialShare';
import Branch from '../services/Branch';
import imgPlaceholder from '../assets/images/placeholder.png';
import PremiumIndicator from '../components/PremiumIndicator';
import Breadcrumb from '../components/DetailPageBreadcrumb';
import MoreOfCategory from '../components/MoreOfCategory';
import PodcastCover from '../components/PodcastCover';
import Event from '../services/PlayerEvent';
import pageMixin from '../shared/pageMixin';

export default {
  name: 'ShowDetails',
  components: {
    Loader,
    LoginModal,
    CardListWrapper,
    PodcastList,
    PodcastCard,
    Rating,
    SocialShareDialog,
    PremiumBanner,
    PremiumIndicator,
    Breadcrumb,
    MoreOfCategory,
    PodcastCover,
    'premium-modal': PremiumContentModal,
  },
  mixins: [pageMixin],
  data() {
    return {
      imgPlaceholder,
      pageName: 'Show Detail Page',
      show_data: {},
      data_loaded: false,
      show_nav: true,
      episodes: [],
      user_service: new User(),
      podcast_service: new Podcast(),
      episode_service: new Episode(),
      branch_service: new Branch(),
      libraryEpisodes: [],
      libraryPodcasts: [],
      relatedPodcasts: [],
      adding_podcast: false,
      podcasts_fetched: false,
      filter_value: 1,
      show_thumbs_up_rating: false,
      show_thumbs_down_rating: false,
      episode_meta: {},
      episode_key_map: {},
      show_login: false,
      open_share_dialog: false,
      episodesList: [],
      allEpisodes: [],
      current_page: 1,
      page_size: 10,
      pager_count: 7,
      select_filters: [
        {
          name: 'Newest',
          val: 1,
          sortOrder: 'desc',
          sortBy: 'released_at',
        },
        {
          name: 'Oldest',
          val: 2,
          sortOrder: 'asc',
          sortBy: 'released_at',
        },
        {
          name: 'Shortest',
          val: 3,
          sortOrder: 'asc',
          sortBy: 'runtime',
        },
        {
          name: 'Longest',
          val: 4,
          sortOrder: 'desc',
          sortBy: 'runtime',
        },
      ],
      selected_filter: {
        sortBy: 'released_at',
        sortOrder: 'desc',
      },
      season_trailers: [],
      no_more_data: false,
      totalEpisodes: 0,
      default_current_page: 1,
      breadcrumbTrail: [],
      podcastCategory: null,
      show_premium_modal: false,
      loadingEpisodes: false,
      eventProvider: new Event(),
      showingMoreDescription: false,
    };
  },
  computed: {
    total_episodes() {
      if (!this.show_data || !this.show_data.seasons || !this.show_data.seasons.length) {
        return 0;
      }
      return this.show_data.seasons.reduce(((total, elem) => (total + ((elem.episodes && elem.episodes.length) || 0))), 0);
    },
    isLoggedIn() {
      return this.$store.getters.loggedIn;
    },
    showPremiumBanner() {
      const { user } = this.user_service;

      if (!user) {
        return true;
      }

      if (user && !user.is_subscribed) {
        return true;
      }

      return false;
    },
    hasAccessToPremium() {
      const { user } = this.user_service;

      if (!user) {
        return false;
      }

      if (user && user.is_subscribed) {
        return true;
      }

      return false;
    },
    isShowExclusive() {
      return this.show_data.is_exclusive;
    },
    inUserLibrary() {
      const userPodcast = this.$store.getters.searchPodcastInLibrary(this.show_data.uuid);
      if (userPodcast && userPodcast.uuid) {
        return userPodcast;
      }
      return null;
    },
    currentlyPlaying() {
      return this.$store.getters.episode;
    },
    isPlayingTrailer() {
      const { play } = this.$store.getters;

      return this.season_trailers.length && play && this.currentlyPlaying && (this.currentlyPlaying.uuid === this.season_trailers[0].uuid);
    },
    isLoadingTrailer() {
      const { status } = this.$store.getters;

      return this.season_trailers.length && status === 'loading' && this.currentlyPlaying && (this.currentlyPlaying.uuid === this.season_trailers[0].uuid);
    },
    hasFreeEpisodes() {
      return this.show_data && this.show_data.has_free_episodes;
    },
  },
  beforeMount() {
    this.getPodcast();
  },
  mounted() {
    if (window.innerWidth <= 567) {
      this.pager_count = 3;
    }
  },
  destroyed() {
    this.setMetaInformation();
  },
  methods: {
    toggleDescription() {
      this.showingMoreDescription = !this.showingMoreDescription;
      setTimeout(() => {
        this.mapTargetBlankToAnchorTags('.show-details__info .description a');
      }, 10);
    },
    getPodcast() {
      const uuid = this.$route.params.podcastID;
      this.podcast_service.getPodcastById(uuid).then((resp) => {
        this.show_data = resp;
        this.data_loaded = true;

        this.getPodcastEpisodesByPodcastUuid();
        this.getSeasonTrailers();
        this.setPodcastCategory();

        if (this.podcastCategory) {
          this.constructBreadcrumbTrail();
        }
        this.eventProvider.triggerShowDetailsViewedEvent(this.show_data);

        this.setMetaInformation(`${this.show_data.title} | Listen ${this.show_data.is_exclusive ? 'Only' : ''} on Luminary`, this.show_data.description);
      }).catch(() => {
        this.data_loaded = true;
      });
    },
    setPodcastCategory() {
      if (this.show_data && this.show_data.categories && this.show_data.categories.length) {
        [this.podcastCategory] = this.show_data.categories;
      }
    },
    constructBreadcrumbTrail() {
      this.breadcrumbTrail = [
        {
          name: this.podcastCategory.name,
          link: `/listen/category/${this.podcastCategory.slug}/${this.podcastCategory.uuid}`,
        },
        {
          name: this.show_data.title,
        },
      ];
    },
    getPodcastEpisodesByPodcastUuid() {
      const podcastUUID = this.show_data.uuid;
      const params = {
        sortBy: this.selected_filter.sortBy,
        sortOrder: this.selected_filter.sortOrder,
        p: this.current_page++,
        limit: this.page_size,
      };
      this.getPodcastEpisodes(podcastUUID, params, true);
    },
    reorderSeasons() {
      this.show_data.seasons = this.show_data.seasons.sort((a, b) => b.number - a.number);
    },
    getSeasonTrailers() {
      this.podcast_service
        .getPodcastTrailers(this.show_data.uuid)
        .then((res) => {
          this.season_trailers = res.trailers || [];
          this.season_trailers = this.season_trailers.sort((a, b) => new Date(b.released_at) - new Date(a.released_at));
        })
        .catch((error) => {
          log.warn(error.message);
        });
    },
    displayEpisodes() {
      this.show_data.seasons.forEach((elem, index) => {
        this.episodes = elem.episodes.map((item) => {
          const returnEpisodes = {
            ...item,
            mainPhoto: this.show_data.display_image_url,
            season: this.show_data.seasons[index],
            season_id: item.season_uuid,
            show_data: this.show_data,
            episode_id: item.uuid,
          };
          log.info(returnEpisodes);
          return returnEpisodes;
        });
      });
      this.sortByLatestEpisodes();
    },
    sortByLatestEpisodes() {
      this.episodes.sort((a, b) => new Date(b.released_at) - new Date(a.released_at));
    },
    sortByOldestEpisodes() {
      this.episodes.sort((a, b) => new Date(a.released_at) - new Date(b.released_at));
    },
    addShowToLibrary(id) {
      this.show_login = !this.isLoggedIn;
      if (this.show_login) return;
      this.show_premium_modal = this.isShowExclusive && !this.hasAccessToPremium && !this.hasFreeEpisodes;
      if (this.show_premium_modal) return;

      if (this.inUserLibrary && this.inUserLibrary.uuid) {
        this.deletePodcast();
      } else {
        this.adding_podcast = true;
        this.podcast_service
          .addPodcastsToLibrary(id)
          .then((res) => {
            if (res && res.success) {
              this.$store.dispatch('setUserLibraryPodcast', { uuid: res.uuid, podcast_uuid: id });
              this.$set(this.show_data, 'record_id', res.uuid);
            }
            this.adding_podcast = false;

            // this.showSuccessMsg('Successfully added to library.');
            this.eventProvider.triggerMyShowsAddEvent(this.show_data);
          })
          .catch((error) => {
            log.warn(error);
            this.adding_podcast = false;

            this.showErrorMsg('An error occurred. Please try again later.');
          });
      }
    },
    filterSelect() {
      this.select_filters.forEach((elem) => {
        if (this.filter_value === elem.val) {
          this.selected_filter.sortBy = elem.sortBy;
          this.selected_filter.sortOrder = elem.sortOrder;
          this.eventProvider.triggerSDPSortEvent(this.show_data, elem.name);
        }
      });
      this.getFilteredData();
    },
    getCategoryPodcasts() {
      const ctx = this;
      if (
        this.show_data
        && this.show_data.category
        && this.show_data.category.uuid
      ) {
        this.podcast_service
          .getPodcastByCategoryId(this.show_data.category.uuid)
          .then((resp) => {
            if (resp && resp.podcast && resp.podcast.length) {
              ctx.relatedPodcasts = resp.podcast.slice(0, 10); // display only 10 podcasts from current category in carousel list
              ctx.show_nav = ctx.relatedPodcasts && ctx.relatedPodcasts.length > 5;
            }
          })
          .catch((error) => {
            log.warn(error);
            this.adding_podcast = false;

            this.showErrorMsg(error);
          });
      }
    },
    deletePodcast() {
      this.adding_podcast = true;
      this.podcast_service
        .deletePodcastFromLibrary(this.inUserLibrary.uuid)
        .then((res) => {
          if (res && res.success) {
            // this.showSuccessMsg('Podcast deleted from your library.');
            this.$store.dispatch('removeUserLibraryPodcast', this.inUserLibrary.podcast_uuid);
            this.eventProvider.triggerMyShowsRemoveEvent(this.show_data);
          } else {
            this.showErrorMsg('An error occurred. Please try again later.');
          }
          this.adding_podcast = false;
        })
        .catch((error) => {
          this.adding_podcast = false;
          log.warn(error);
        });
    },
    playTrailer() {
      const trailer = this.season_trailers[0];

      if (this.currentlyPlaying.uuid === this.season_trailers[0].uuid) {
        const { play } = this.$store.getters;

        if (!play) {
          if (this.currentlyPlaying.episode_type !== 'trailer') {
            this.eventProvider.triggerEpisodePauseEvent(this.currentlyPlaying, 'trailer_select');
          }
          this.$store.dispatch('play');
          this.eventProvider.triggerTrailerPlayEvent(trailer, 'sdp_select');
        } else {
          this.$store.dispatch('pause');
          this.eventProvider.triggerTrailerPauseEvent(trailer, 'sdp_pause');
        }
      } else {
        trailer.episode_type = 'trailer';
        trailer.display_image_url = this.show_data.display_image_url || this.show_data.image_url;

        if (this.currentlyPlaying.episode_type !== 'trailer') {
          this.eventProvider.triggerEpisodePauseEvent(this.currentlyPlaying, 'trailer_select');
        }

        this.loadMediaInPlayer(trailer.media_url, trailer.is_exclusive);
        this.$store.dispatch('setAndPlayEpisode', trailer);
        this.eventProvider.triggerTrailerPlayEvent(trailer, 'sdp_select');
      }
    },
    openShareDialog() {
      this.open_share_dialog = true;
    },
    hideShareDialog() {
      this.open_share_dialog = false;
    },
    loadMoreEpisodes() {
      this.current_page++;
      this.getPodcastEpisodesByPodcastUuid();
    },
    loadNextPage(event) {
      this.current_page = event;
      this.getPodcastEpisodesByPodcastUuid();
    },
    getFilteredData() {
      const podcastUUID = this.$route.params.podcastID;
      const params = {
        sortBy: this.selected_filter.sortBy,
        sortOrder: this.selected_filter.sortOrder,
        p: 1,
        limit: this.page_size,
      };
      this.getPodcastEpisodes(podcastUUID, params, true);
    },
    getPodcastEpisodes(podcastUUID, params, orverride) {
      this.loadingEpisodes = true;
      this.podcast_service
        .getPodcastEpisodesByPodcastUuid(podcastUUID, params)
        .then((res) => {
          log.info(res);
          if (!res || !res.episodes || !res.episodes.length) {
            this.no_more_data = true;
          }
          this.totalEpisodes = res && res.total ? res.total : 0;
          if (res && res.episodes && res.episodes.length && orverride) {
            this.episodesList = res.episodes;
            this.current_page = 1;
          } else if (res && res.episodes && res.episodes.length && !orverride) {
            this.episodesList = this.episodesList.concat(res.episodes);
          }

          this.loadingEpisodes = false;
          // this.setupEpisodeMeta();
          this.mapTargetBlankToAnchorTags('.show-details__info .description a');
        })
        .catch((error) => {
          log.info(error);
          this.loadingEpisodes = false;
          this.mapTargetBlankToAnchorTags('.show-details__info .description a');
        });
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";

.show-details {
  .content-wrapper {
    position: relative;
  }

  .read-more {
    padding: 0;
  }

  .description {
    > p {
      color: $black;
    }
    margin-bottom: 22px;
  }

  h2.show-title {
    margin: 30px 0 15px;
    font-size: 40px;
    font-weight: 500;
    line-height: 44px;

    @media (max-width: 900px) {
      font-size: 35px;
    }

    @media (max-width: 767px) {
      font-size: 40px;
    }
  }

  .interact {
    display: flex;
    align-items: center;

    .el-button {
      margin-right: 24px;
      &.btn-primary-transparent {
        background-color: transparent;
      }

      @media (max-width: 567px) {
        margin-right: 16px;
        padding: 11px;
      }
    }
  }

  &.is-exclusive {
    .content-wrapper {
      &.is-mobile {
        display: none;

        @media (max-width: 767px) {
          display: block;
        }

        .premium-indicator {
          margin-top: 20px;
        }
      }

      .cover-section {
        padding: 50px 0 0;
        position: relative;

        // @media (max-width: 900px) {
        //   padding: 0;
        // }

        > .container {
          padding: 0 0 0 60px;

          @media (max-width: 1024px) {
            padding: 0;
          }
        }

        background-size: cover;
        background-position: center center;

        min-height: 250px;
        width: 100%;

        box-sizing: border-box;

        @media (max-width: 1024px) {
        }

        &__content {
          display: flex;
          padding-left: 340px;
          position: relative;

          .show-image {
            position: absolute;
            left: 0;

            @media (max-width: 1024px) {
              height: 287px;
              width: 287px;
            }
          }

          &__text {
            width: 100%;
            z-index: 1;

            h2 {
              color: white;
              margin: 20px 0;

              @media (max-width: 900px) {
                font-size: 35px;
              }
            }

            .publisher {
              margin: 0 0 10px;
              color: white;
              @media (max-width: 1023px) {
                font-size: 16px;
              }

              @media (max-width: 767px) {
                color: $gray;

                margin: 0 0 20px;
              }
            }

            .premium-indicator {
              margin-top: 20px;
            }
          }
        }

        &::before {
          content: "";
          top: 0;
          left: 0;

          width: 100%;
          height: 100%;

          position: absolute;
          z-index: 0;

          background-color: rgba(0, 0, 0, 0.8);
        }
      }

      &__details {
        > .container {
          padding-left: 400px;

          @media (max-width: 1024px) {
            padding-left: 340px;
          }
        }
      }

      @media (max-width: 767px) {
        &:not(.is-mobile) {
          display: none;
        }
      }
    }
  }

  &__info {
    margin-top: 40px !important;
    padding: 0 60px;

    display: flex;

    @media (max-width: 767px) {
      flex-direction: column;
    }

    .text {
      overflow-x: hidden;
      margin-left: 80px;

      .publisher {
        color: $gray;
        font-size: 16px;
        font-family: Favorit-Light;
        font-weight: bold;
        letter-spacing: 0.2px;
        display: inline-block;
        margin: 0 0;
        &:hover{
          text-decoration: underline;
          cursor: pointer;
        }
      }

      @media (max-width: 1024px) {
        margin-left: 60px;
      }

      @media (max-width: 767px) {
        margin-left: 0;

        .el-breadcrumb {
          margin-top: 30px;
        }
      }
    }

    @media (max-width: 1024px) {
      padding: 0;
    }
  }

  &.is-exclusive {
    .content-wrapper {
      .show-details__info {
        padding: 40px 60px 0;
        margin-top: 0 !important;

        @media (max-width: 1024px) {
          padding: 40px 0 0;
        }

        @media (max-width: 767px) {
          padding: 40px 0 40px;
        }
      }
    }

    .show-details__info {
      .el-breadcrumb {
        margin-top:40px;

        @media (max-width: 1023px) {
          margin-top: 0;
        }

        @media (max-width: 767px) {
          margin-top: 30px;
        }
      }

      h2 {
        color: white;
        margin: 20px 0;

        @media (max-width: 1023px) {
          font-size: 40px;
        }
      }

      .description {
        > p {
          @media (max-width: 767px) {
            color: white !important;
          }
        }
      }

      .publisher {
        margin: 0 0 60px;
        color: white;

        @media (max-width: 1023px) {
          font-size: 16px;
        }

        @media (max-width: 767px) {
          color: $gray;

          margin: 0 0 20px;
        }
      }
    }
  }

  .show-image {
    position: relative;
    flex-shrink: 0;
  }

  .episodes-count {
    margin-top: 50px;
    padding: 0 60px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-bottom: 16px;

    > p {
      font-size: 24px;
      color: $black;

      @media (max-width: 1024px) {
        padding: 0;
      }
    }

    @media (max-width: 1024px) {
      padding: 0;
    }
  }

  .episodes-list-container {
    position: relative;

    @media (max-width: 1024px) {
      width: 100%;
    }

    .season-number {
      background-color: $xxlight-gray;
      padding: 20px 60px 0;

      @media (max-width: 1024px) {
        padding: 20px 44px 0 30px;
      }

      @media (max-width: 1024px) {
        padding: 20px 44px 0 30px;
      }

      @media (max-width: 567px) {
        padding: 20px 30px 0;
      }

      display: flex;
      align-items: center;

      .container {
        display: flex;
        align-items: center;
      }

      .horizontal-line {
        flex: 1;
        height: 1px;

        background-color: $xlight-gray;
      }

      p {
        margin: 0 15px 0 0;
      }
    }
  }

  .el-pagination {
    margin: 40px 0 25px;
    .btn-prev .el-icon, .btn-next .el-icon{
      font-size: 24px;
      color: $light-gray2;
    }
    .btn-prev {
      padding-right: 0px;
    }
    .btn-next {
      padding-left: 0px;
    }
    .el-pager {
      margin: 0 40px;
    }
    .el-pager li {
      min-width: auto;
      margin-right: 32px;
    }
    .el-pager li.number {
      font-size: 16px;
      color: $black;
      min-width: 8px;
    }
    .el-pager li.number:last-child {
      margin-right: 0px;
    }
    .el-pager li.number.active {
      font-size: 16px;
      color: $blue;
    }
  }

  .el-select.episode-sort {
    width: 130px;
    cursor: pointer;
    .el-input {
      .el-input__inner {
        border-radius: 20px !important;
        color: $black !important;
        border: 1px solid $black !important;
        font-weight: 500;
        padding: 0 15px 0px 30px;
        font-size: 14px !important;
        height: 32px;
        line-height: 4px;
      }
      .el-input__inner::placeholder {
        font-weight: 500 !important;
      }
      .el-input__suffix {
        i {
          font-size: 12px;
          color: $black !important;
          line-height: 0 !important;
        }
      }
    }
  }
  .el-select.episode-sort::before {
    content: "";
    position: absolute;
    z-index: 1;
    background: url(../assets/images/ic_sort_icon.svg) no-repeat;
    width: 13px;
    height: 13px;
    left: 12px;
    top: 12px;
    background-size: contain;
  }
}
@media (max-width: $xs) {
  .show-details {
    .el-pager {
      padding:0 25px;
      margin: 0 0 !important;
      li {
        margin-right: 0 !important;
        padding-right: 22px;
        &:last-child {
          padding-right: 0 !important;
        }
      }
    }
  }
}
@media (max-width: $xxs) {
  .show-details {
    .el-pager {
      padding:0 8px;
      li {
        padding-right: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/ShowDetails.vue